import React, { useContext, forwardRef } from 'react'
import { Path } from 'react-native-svg'

import { IconContext } from '../context'

export const WebsiteIcon = forwardRef<Path>((props, ref) => {
  const iconContext = useContext(IconContext)

  return (
    <Path
      ref={ref}
      d='M12 1.999c5.524 0 10.002 4.478 10.002 10.002 0 5.523-4.478 10.001-10.002 10.001-5.524 0-10.002-4.478-10.002-10.001C1.998 6.477 6.476 1.999 12 1.999zM14.939 16.5H9.06c.652 2.414 1.786 4.002 2.939 4.002s2.287-1.588 2.939-4.002zm-7.43 0H4.785a8.532 8.532 0 004.094 3.411c-.522-.82-.953-1.846-1.27-3.015l-.102-.395zm11.705 0h-2.722c-.324 1.335-.792 2.5-1.373 3.411a8.528 8.528 0 003.91-3.127l.185-.283zM7.094 10H3.735l-.005.017a8.525 8.525 0 00-.233 1.984c0 1.056.193 2.067.545 3h3.173a20.847 20.847 0 01-.123-5zm8.303 0H8.603a18.966 18.966 0 00.135 5h6.524a18.974 18.974 0 00.135-5zm4.868 0h-3.358c.062.647.095 1.317.095 2a20.3 20.3 0 01-.218 3h3.173a8.482 8.482 0 00.544-3c0-.689-.082-1.36-.236-2zM8.88 4.09l-.023.008A8.531 8.531 0 004.25 8.5h3.048c.314-1.752.86-3.278 1.583-4.41zM12 3.499l-.116.005C10.62 3.62 9.396 5.622 8.83 8.5h6.342c-.566-2.87-1.783-4.869-3.045-4.995L12 3.5zm3.12.59l.107.175c.669 1.112 1.177 2.572 1.475 4.237h3.048a8.533 8.533 0 00-4.339-4.29l-.291-.121z'
      stroke='none'
      fill={iconContext.color}
      fillOpacity={1}
    />
  )
})

WebsiteIcon.displayName = 'WebsiteIcon'

export default WebsiteIcon
